import { FormEventHandler, useEffect, useRef } from "react"

import { FormField } from "../../common/interfaces"

import styles from "./style.module.scss"

import { Input } from "ui-kit/components-branded/FormControls/Input/Input"
import { ActionButtons } from "modules/ClientAuthorization/components/ActionButtons"
import { focusInput } from "utils/helpers/focusInput"

interface Props {
    handleSubmit: FormEventHandler<HTMLFormElement>
    showErrors: boolean
    buttonDisabled: boolean
    emailField: FormField
}

export const LoginCard = ({ handleSubmit, showErrors, buttonDisabled, emailField }: Props) => {
    const emailInputRef = useRef<HTMLInputElement>(null)

    useEffect(() => {
        if (showErrors && emailField.error) {
            focusInput(emailInputRef)
        }
    }, [showErrors, emailField.error])

    return (
        <form onSubmit={handleSubmit} className={styles.container}>
            <div className={styles.text}>
                Если вы&nbsp;уже подбирали психолога или у&nbsp;вас были сессии, то&nbsp;войдите,
                указав почту.
            </div>
            <div>
                <Input
                    ref={emailInputRef}
                    error={emailField.error}
                    name="email"
                    placeholder="Ваша почта"
                    value={emailField.value}
                    onChange={emailField.setValue}
                    autoFocus
                />
                <ActionButtons
                    showPersonalInfo
                    disabled={buttonDisabled}
                    actionButtonLabel="Войти"
                />
            </div>
        </form>
    )
}
